module.exports = __webpack_public_path__ + "static/media/360_Desktop6_EN.1aa63fc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/360_Desktop6_EN.png
// module id = 564
// module chunks = 0